const importAll = function (r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
};

var images = importAll(require.context('../images', false, /\.(png|jpe?g|svg)$/));

module.exports = {
    images: images
}


// WEBPACK FOOTER //
// ./src/js/globals.js